import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useCallback, useMemo } from 'react'
import {
  useGetBillToLocationUrl,
  useGetServiceLocationUrl,
} from '@user/store/authorization/hooks'
import { styles } from './useStyles'
import Link from '@mui/material/Link'

export const GridLocationLink: FC<{
  locationId?: any
  locationCode?: any
  variant: 'billto' | 'service'
}> = ({ locationId, locationCode, variant }) => {
  const billToLocationUrl = useGetBillToLocationUrl(
    typeof locationId === 'string' ? locationId : undefined,
  )

  const serviceLocationUrl = useGetServiceLocationUrl(
    typeof locationId === 'string' ? locationId : undefined,
  )

  const onClick = useCallback((e: React.MouseEvent) => e.stopPropagation(), [])

  const shouldRender = useMemo(
    () => typeof locationId === 'string' && typeof locationCode === 'string',
    [locationCode, locationId],
  )

  const theme = useTheme()

  return shouldRender ? (
    <Link
      href={variant === 'billto' ? billToLocationUrl : serviceLocationUrl}
      onClick={onClick}
      target="_blank"
      sx={styles.link}
      data-test-id={`grid-location-link-${variant}-${locationId}`}
    >
      <>
        {locationCode}
        <img
          src="/static-assets/icons/arrow-northeast.svg"
          style={{
            margin: `0 0 ${theme.spacing(0.3)} ${theme.spacing(0.5)}`,
          }}
        />
      </>
    </Link>
  ) : null
}
GridLocationLink.displayName = 'GridLocationLink'
